import React from "react";

export default function Hero() {
  return (
    <div className="relative min-h-[calc(100vh-4rem)] w-full flex flex-col items-center justify-center bg-Base transition-colors duration-300 selection:bg-Sapphire selection:text-Base px-6">
      <div className="flex flex-col items-center text-center animate-fade-up">
        <p className="label-caps mb-10">Maribor · Slovenia</p>

        <h1 className="font-display font-light text-Text text-6xl sm:text-7xl md:text-8xl leading-[1.05] mb-10">
          Tadej Gungl<span className="text-Sapphire">*</span>
        </h1>

        <div className="w-16 border-t hairline mb-10"></div>

        <p className="font-mono text-sm md:text-base text-Text uppercase tracking-[0.2em] mb-4">
          <span className="text-Sapphire">*</span> Systems & Software Engineer
        </p>

        <p className="font-mono text-sm text-Subtext0">
          Rust · Systems · ML · Open Source
        </p>
      </div>

      {/* Scroll Cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <span className="label-caps">scroll ↓</span>
      </div>
    </div>
  );
}
